import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as FaceSvg } from '../../../../assets/images/face.svg';
import { ReactComponent as MenuSvg } from '../../../../assets/images/menu.svg';
import { ReactComponent as BagSvg } from '../../../../assets/images/bag.svg';
import { ReactComponent as FridgeSvg } from '../../../../assets/images/fridge.svg';
import { ReactComponent as CheckSvg } from '../../../../assets/images/checkGray.svg';

export const YouWillGetComponent = () => {
  const services = [
    {
      icon: <MenuSvg />,
      title: t('onboarding.whatYouGet.mealPlan.title'),
      description: t('onboarding.whatYouGet.mealPlan.description'),
    },
    {
      icon: <FaceSvg />,
      title: t('onboarding.whatYouGet.fullControl.title'),
      description: t('onboarding.whatYouGet.fullControl.description'),
    },
    {
      icon: <BagSvg />,
      title: t('onboarding.whatYouGet.groceryList.title'),
      description: t('onboarding.whatYouGet.groceryList.description'),
    },
    {
      icon: <MenuSvg />,
      title: t('onboarding.whatYouGet.rec.title'),
      description: t('onboarding.whatYouGet.rec.description'),
    },
    {
      icon: <CheckSvg />,
      title: t('onboarding.whatYouGet.tracking.title'),
      description: t('onboarding.whatYouGet.tracking.description'),
    },
    {
      icon: <FridgeSvg />,
      title: t('onboarding.whatYouGet.mealIdeas.title'),
      description: t('onboarding.whatYouGet.mealIdeas.description'),
    },
  ];
  return (
    <>
      <Title tag='h4' className={styles.eatTitle}>
        {t('onboarding.highlights.title.start2')}
        <span> {t('onboarding.highlights.title.end2')}</span>
      </Title>

      <div className={styles.services}>
        {services.map((service, index) => (
          <div className={styles.service} key={index}>
            <div style={{ width: 36 }}>{service.icon}</div>
            <div className={styles.serviceText}>
              <Text semibold>{service.title}</Text>
              <span>{service.description}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
